module.exports = __webpack_public_path__ + "img/9.5359cce5.png";